import Link from 'next/link'

import { useEffect, useState } from 'react'
import { CalendarDays } from 'lucide-react'
import { cn } from '@/lib/utils'
import { buttonClass } from '@/lib/ui'
import Brand from '@/components/generals/brand'
import { NAV_LINKS } from '@/constants/site'

export default function Header() {
    const [scrolled, setScrolled] = useState(false)

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 8)

        handleScroll()
        window.addEventListener('scroll', handleScroll, { passive: true })

        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    return (
        <header
            className={cn(
                'sticky top-0 z-50 border-b transition-[background-color,border-color,box-shadow] duration-300',
                scrolled ? 'border-border/70 bg-background/85 shadow-[0_8px_30px_-18px_rgb(0_0_0/0.25)] backdrop-blur-md' : 'border-transparent bg-background'
            )}
        >
            <div className='mx-auto flex h-18 max-w-7xl items-center justify-between gap-6 px-4 sm:px-6 lg:px-8'>
                <Brand />

                <nav aria-label='Principal' className='flex items-center gap-1 sm:gap-2'>
                    {NAV_LINKS.map(link => (
                        <Link
                            key={link.href}
                            href={link.href}
                            className='hidden rounded-full px-4 py-2 text-sm font-medium text-foreground/75 transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring md:inline-flex'
                        >
                            {link.label}
                        </Link>
                    ))}

                    <Link href='/#reservar' className={buttonClass('primary', 'sm', 'ml-2 sm:h-10 sm:px-5')}>
                        <CalendarDays className='size-4' aria-hidden='true' />
                        Reservar
                    </Link>
                </nav>
            </div>
        </header>
    )
}
